/**
 * filter default interface
 */

import { LoadPropType } from '@/components/select/types';
import { RoleEnum } from '@/store/user';

export interface Filter {
    filterSettings: FilterSettings,
    index: number,

    SET_FILTER: (filter: string) => void,
    SET_FILTER_PREVIEW: (filterPreview: any) => void,
    SET_PAGE: (number: number) => void,
    SET_SEARCH: (params: { key: string; value: string }) => void,

    setFilterName: (filterName: string) => void,
    setTemplateClassName: (className: string | string[]) => void,
    setBtnClassName: (className: string) => void,
    setFilterModel: (filterModel: Record<string, any>) => void,
    setFilterHandlers: (filterHandlers: FilterHandlers) => void,
    init: () => void,

    prepareDatePicker: (filterEntity: any) => { string: string; preview: any },

    updateFilter: () => void,
    resetFilter: () => void,
    updateSearch: (params: { key: string; value: string }) => void,
    resetSearch: (key: string) => void,
    updateCheckbox: (params: { key: string; checkbox: any }) => void,
    resetCheckboxList: (key: string) => void,
    updateSelect: (params: { key: string; value: { id: number | string; value: string } }) => void,
    resetSelect: (key: string) => void,
    updateMultiSelect: (params: { key: string; value: { id: number; value: string } }) => void,
    resetMultiSelect: (key: string) => void,
    updateRadio: (arams: { key: string; value: string }) => void,
    resetRadio: (key: string) => void,
    updateSelectList: (params: { key: string; list: any }) => void,
    updateMultiSelectList: (params: { key: string; list: any }) => void,
    updateLoad: (params: { key: string; value: LoadPropType }) => void,

    prepareFilterFromModal: () => Promise<{ string: string; preview: any }>,
    setFiltersModelFromLocalStorage: (params: { filterName: string; key: string }) => void,
}

export interface FilterSettings {
    name: string,
    getListAction: string,
    pageCurrent: number,
    sort: FilterSort,
    filter: string,
    filterAdditional?: string,
    filterPreview: {
        [key: string]: Record<string, any>,
    },
    filterModel: FilterModel,
    filterValues: string | Record<string, any>,
    filterHandlers: FilterHandlers,
    templateClass: string | string[],
    btnClass: string,
}

export interface FilterModel {
    [key: string]: FilterEntityModel,
}

interface FilterEntityModel {
    key: string,
    title: string,
    placeholder?: string,
    name?: string,
    type?: FilterType,
    value?: string | boolean | null,
    action: string,
    initAction?: string,
    clearAction?: string,
    handler: string,
    list?: any,
    iconClass?: string,
    previewName: string,
    current?: {
        id: number | string,
        value: string,
    },
    load?: LoadPropType,
}

export interface FilterSort {
    [key: string]: SortItem,
}

export interface SortItem {
    key: string,
    sort: string,
}

export interface FilterHandlers {
    update: string,
    reset: string,
    resetState: string,
    removeSelected: string,
}

export interface BaseFilter {
    roles: RoleEnum[], // roles that can use that filter, empty means 'anyone'
}

export enum FilterType {
    Hidden = 'hidden',
    Text = 'text',
    Select = 'select',
    Autocomplete = 'autocomplete',
    Multiselect = 'multi-select',
    Checkbox = 'checkbox',
    Radio = 'radio',
    Datepicker = 'date-picker',
    IntervalDatepicker = 'interval-date-picker',
}
